"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingStars = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const setStars = (numberOfFilled) => [...Array(5).keys()].map((i) => ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: i < Math.round(numberOfFilled) ? ["fas", "star"] : ["fal", "star"], color: "yellow" }, i)));
const RatingStars = ({ rate, className }) => {
    return (0, jsx_runtime_1.jsx)(Wrapper, { className: className, children: setStars(rate) }, void 0);
};
exports.RatingStars = RatingStars;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  display: inline-flex;

  & > div:not(:last-of-type) {
    margin-right: ${({ theme }) => theme.spacings.xxs};
  }
`;
//# sourceMappingURL=RatingStars.js.map